
import { Base } from '../base-component';
import './cookie-policy.component.scss';

export class CookiePolicy extends Base {

	acceptCookieButton: Element;
	cookieBox: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.acceptCookieButton = this.element.querySelector('.js-accept-cookie-policy');
		this.cookieBox = this.element;

		// TODO: Remove on go live. For testing purposes only.
		//this.unsetCookies();

		if (typeof(Storage) !== 'undefined' && !localStorage.standardbank) {
			this.toggleCookieBox('open');
		}

	}

	bindEvents() {
		this.acceptCookieButton.addEventListener('click', () => this.acceptCookies());
	}

	toggleCookieBox(state) {

		if (state === 'open') {

			setTimeout(() => {

				this.cookieBox.classList.remove('cookie-policy--hidden');
				this.cookieBox.classList.add('cookie-policy--open');
				this.cookieBox.classList.remove('cookie-policy--closed');

			}, 5000);

		} else {

			this.cookieBox.classList.remove('cookie-policy--open');
			this.cookieBox.classList.add('cookie-policy--closed');

			setTimeout(() => {

				this.cookieBox.classList.add('cookie-policy--hidden');

			}, 1500);

		}

	}

	acceptCookies() {
		this.setCookies();
	}

	setCookies() {
		localStorage.standardbank = 'accepted';
		this.toggleCookieBox('closed');
	}

	unsetCookies() {
		localStorage.removeItem('standardbank');
		this.toggleCookieBox('open');
	}
}



// WEBPACK FOOTER //
// ./components/cookie-policy/cookie-policy.component.ts